import { HYDRATE } from 'next-redux-wrapper';

import { IBlackListResponse } from '@r1-frontend/api-domru/api-profile/v1/phone/black-list/get';
import {
    IGetCallsStatResponseDto,
} from '@r1-frontend/api-domru/api-profile/v1/phone/calls-stat/dto/IGetCallsStatResponseDto';
import { IPhoneRedirections } from '@r1-frontend/api-domru/api-profile/v1/phone/redirections/get';

import { THydrateAction } from '~/src/store';

export enum ESettingsPhoneActionTypes {
    FETCH_REDIRECTIONS_LIST = 'REDIRECTIONS/FETCH_REDIRECTIONS_LIST',
    FETCH_CALLS = 'CALLS_INFO/FETCH_DATA',
    ERROR = 'CALLS_INFO/ERROR',
    FETCH_BLACKLIST = 'BLACKLIST/FETCH_BLACKLIST',
    SET_BLACKLIST = 'BLACKLIST/SET_BLACKLIST',
    DEL_NUM_BLACKLIST = 'BLACKLIST/DEL_NUM_BLACKLIST',
    RESET_BLACK_LIST_ERROR = 'BLACKLIST/REST_BLACK_LIST_ERROR'
}

export interface ISettingsPhoneState {
    sessions: IGetCallsStatResponseDto,
    blacklist: IBlackListResponse,
    redirectionsList: IPhoneRedirections[],
}

export const initialState: ISettingsPhoneState = {
    sessions: {
        callsStat: [],
        totalNum: 0,
    },
    blacklist: {
        exist: false,
        guid: '',
        phones: [],
    },
    redirectionsList: [],
};

export type TActions = {
    type: ESettingsPhoneActionTypes,
    payload: Partial<ISettingsPhoneState>,
};

const settingsPhoneReducer = (state = initialState, action: TActions | THydrateAction): ISettingsPhoneState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.settingsPhone };
        case ESettingsPhoneActionTypes.FETCH_REDIRECTIONS_LIST:
            return { ...state, ...action.payload };
        case ESettingsPhoneActionTypes.FETCH_CALLS:
            return { ...state, ...action.payload };
        case ESettingsPhoneActionTypes.FETCH_BLACKLIST:
            return { ...state, ...action.payload };
        case ESettingsPhoneActionTypes.SET_BLACKLIST:
            return { ...state, ...action.payload };
        case ESettingsPhoneActionTypes.DEL_NUM_BLACKLIST:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default settingsPhoneReducer;
